import React from "react";
import { FiChevronRight } from "react-icons/fi";

interface MealTypesListProps {
  meals: {
    meal_type: string;
    meal_name: string;
    count: number;
    total_calories: number;
  }[];
  onMealClick: (meal: { meal_type: string; meal_name: string }) => void;
}

export default function MealTypesList({
  meals,
  onMealClick,
}: MealTypesListProps) {
  if (meals.length === 0) return null;

  return (
    <div className="rounded-xl sm:rounded-2xl border border-stroke bg-white p-4 sm:p-6 shadow-sm dark:border-strokedark dark:bg-boxdark">
      <h5 className="mb-3 sm:mb-4 text-base sm:text-lg font-bold text-gray-900 dark:text-white">
        Tipos de Refeição Mais Consumidos
      </h5>
      <div className="space-y-2 sm:space-y-3">
        {meals.slice(0, 10).map((meal, index) => (
          <div
            key={meal.meal_type}
            onClick={() => onMealClick(meal)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onMealClick(meal);
              }
            }}
            role="button"
            tabIndex={0}
            className="flex cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-gray-50 p-3 sm:p-4 transition-all active:scale-[0.98] touch-manipulation hover:border-purple-300 hover:bg-purple-50 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-purple-500 dark:border-gray-700 dark:bg-gray-800/50 dark:hover:border-purple-700 dark:hover:bg-purple-900/20"
          >
            <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
              <div className="flex h-7 w-7 sm:h-8 sm:w-8 flex-shrink-0 items-center justify-center rounded-full bg-purple-100 text-xs sm:text-sm font-bold text-purple-600 dark:bg-purple-900/30 dark:text-purple-400">
                {index + 1}
              </div>
              <span className="font-medium text-sm sm:text-base text-gray-900 dark:text-white truncate">
                {meal.meal_name}
              </span>
            </div>
            <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0 ml-2">
              <span className="hidden sm:inline text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                {meal.count} refeições
              </span>
              <span className="rounded-full bg-purple-100 px-2 sm:px-3 py-1 text-xs sm:text-sm font-semibold text-purple-700 dark:bg-purple-900/40 dark:text-purple-300 whitespace-nowrap">
                {meal.total_calories.toLocaleString("pt-BR")} kcal
              </span>
              <FiChevronRight
                className="text-gray-400 flex-shrink-0"
                size={18}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
